import * as React from 'react';



export default class Flag extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
        <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" className={this.props.className}>
            <g id="user_popover_bottom" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-597.000000, -220.000000)">
                <g id="Group-60" transform="translate(597.000000, 220.000000)">
                    <path d="M4.30110677,14.8333333 L4.30110677,2.24103931" id="Path-18" stroke="#FF6969"></path>
                    <polygon id="Path-19" fill="#FF6969" points="5.05989583 3.05988534 13.8888889 3.05988534 10.9071926 6.04158161 13.8146035 8.94899252 5.05989583 8.94899252"></polygon>
                </g>
            </g>
        </svg>
    )
  }
}
